/** Expanded sidenav width (px). */
export const SIDENAV_WIDTH_PX = 250;

/** Icon-rail width when unpinned — hugs the logos. */
export const SIDENAV_MINI_WIDTH_PX = 56;

/** Gap between sidenav and page content (px). */
export const SIDENAV_CONTENT_GAP_PX = 8;

export const SIDENAV_LAYOUT_MARGIN_PX = SIDENAV_WIDTH_PX + SIDENAV_CONTENT_GAP_PX;
export const SIDENAV_MINI_LAYOUT_MARGIN_PX = SIDENAV_MINI_WIDTH_PX + SIDENAV_CONTENT_GAP_PX;
